import { inject as injectBranding } from '@angular/core';
import { SiteBrandingService } from '../../services/site-branding.service';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  imports: [FormsModule],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  readonly branding = injectBranding(SiteBrandingService);
  username = '';
  password = '';

  // Holds the message displayed by the login form.
  message = '';
  messageColor = '';

  @Output() closed = new EventEmitter<void>();

  constructor(protected readonly authService: AuthService, private readonly router:Router) {}

  // Preserves the loggedIn property if the template currently uses it.
  get loggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  closePanel(): void {
    this.closed.emit();
  }

  login(): void {
    this.authService.login(this.username, this.password).subscribe({
      next: response => {
        this.message = `${response.role} login successful. Team Portal Unlocked`;
        this.messageColor = 'green';
        //this.closePanel();
      },
      error: error => {
        console.error('Login error:', error);
        this.message = 'Incorrect username or password.';
        this.messageColor = 'red';
      }
    });
  }

  logout(): void {
    this.authService.logout();
    this.message = "Logout Successful."
    this.messageColor = 'green';
    
    this.router.navigate(['/']);
  }
}
